import React from 'react';
import HeaderMenu from '../components/HeaderMenu';

export default function HeaderLayout() {
    return (
        <>
            <HeaderMenu />
            
            {/* Masthead*/}
            <header className="masthead">
                <div className="container h-100">
                    <div className="row h-100 align-items-center justify-content-center text-center">
                        <div className="col-lg-10 align-self-end">
                            <h1 className="text-uppercase text-white font-weight-bold">Seja nosso revendedor</h1>
                            <hr className="divider my-4" />
                        </div>
                        <div className="col-lg-8 align-self-baseline">
                            <p className="text-white-75 font-weight-light mb-5">Venha fazer parte de nossa equipe, produtos de qualidade e garantia!</p>
                            <a className="btn btn-primary btn-xl js-scroll-trigger" href="/revenda">Cadastre-se</a>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}
